export default __webpack_public_path__ + "static/media/bg-card-01.1e7cbf53.jpg";